import Marquee from "react-fast-marquee";
import { useLang } from "./LangContext";

export default function MarqueeBand() {
  const { t } = useLang();
  const text = t.marquee.repeat(2);

  return (
    <div
      data-testid="marquee-band"
      className="border-y border-border bg-background py-6 md:py-8"
    >
      <Marquee speed={40} gradient={false} autoFill>
        <span className="mr-8 font-display text-4xl font-medium uppercase tracking-tight text-foreground md:mr-12 md:text-6xl">
          {text}
        </span>
      </Marquee>
    </div>
  );
}
